module.exports = __webpack_public_path__ + "img/piedmont.9e9f146d.png";